<div class="row">
  <div class="col-12">
    <div class="table-responsive">
      <table class="table caption-top">
        <thead class="border">
        <tr>
          <th nowrap class="text-center border" scope="col" rowspan="2">ลำดับ</th>
          <th nowrap class="text-center border" scope="col" colspan="3">ผลการตรวจสอบ</th>
          <th nowrap class="text-center border" scope="col" rowspan="2">รายการที่ตรวจสอบ</th>
          <th nowrap class="text-center border" scope="col" rowspan="2">คำอธิบาย</th>
        </tr>
        <tr>
          <th nowrap class="text-center border-end">ผ่าน</th>
          <th nowrap class="text-center border-end">ไม่ผ่าน</th>
          <th nowrap class="text-center maxw-250px">หมายเหตุ</th>
        </tr>
        </thead>
        <tbody>
          @for (chk of checklist(); let idx = $index; track chk) {
            <tr>
              <td class="text-center border-end">{{ idx + 1 }}</td>
              <td class="text-center border-end">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" [value]="true" type="radio" [ngModel]="chk.result"
                         style="cursor: not-allowed;" (click)="onRadioClick($event)"/>
                </div>
              </td>
              <td class="text-center border-end">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" [value]="false" type="radio" [ngModel]="chk.result"
                         style="cursor: not-allowed;" (click)="onRadioClick($event)"/>
                </div>
              </td>
              <td class="maxw-300px border-end">
                <div [innerHTML]="(chk.remark || '-') | preline: '<br/>'"></div>
              </td>
              <td class="border-end">{{ chk.checklist?.checklist }}</td>
              <td>{{ chk.checklist?.remark }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="6">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
